import { css } from 'emotion';

export const filterOverlay = css`
  width: 320px;
  max-height: 380px;
`;
